<app-userapi-shared-oauth [userApi]="userApi" [configured]="userApi.url !== undefined">
  <p [innerHTML]="'INCLUDE_MODALUSERAPI_LABEL_ZOHO' | translate"></p>

  <div class="flex space-x-2 mb-12">
    @if (userApi.api.urlPrefix) {
      <div class="my-auto text-green-500">{{ userApi.api.urlPrefix }}</div>
    }

    <div class="w-full">
      <!-- domains are taken from this list https://www.zoho.com/bookings/help/api/v1/domain-specificapiurls.html -->
      <app-dropdown
          [hasSelectedItem]="!!userApi.url"
          [items]="[
            { value: 'com', displayName: 'United States of America (.com)' },
            { value: 'eu', displayName: 'European Union (.eu)' },
            { value: 'in', displayName: 'India (.in)' },
            { value: 'com.au', displayName: 'Australia (.com.au)' },
            { value: 'com.cn', displayName: 'China (.com.cn)' },
            { value: 'jp', displayName: 'Japan (.jp)' },
            { value: 'sa', displayName: 'Saudi Arabia (.sa)' },
            { value: 'ca', displayName: 'Canada (.ca)' }
          ]"
          [selectedItemDisplayName]="userApi.url"
          (itemSelected)="userApi.url = $event.value; userApi.valid = true"></app-dropdown>
    </div>

    @if (userApi.api.urlPostfix) {
      <div class="my-auto">{{ userApi.api.urlPostfix }}</div>
    }
  </div>
</app-userapi-shared-oauth>
